export default {
    data: function() {
        return {
            region: null
        }
    },
    computed: {
        basePath: function() {
            return '/' + this.$route.params.showcase
        }
    },
    mounted: function() {
        this.region = this.$route.query.region;

        if(this.region === null || this.region === undefined || this.region === '')
        {
            this.region = 1;
        }
    },
    methods: {
        gosignup: function() {
            window.location.href = `${this.basePath}/signup?region=${this.region}`
        },
        gopreview: function() {
            window.location.href = `${this.basePath}/preview?region=${this.region}`
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/showcase/home/homeMixin.js